import { render } from "./AnnotationBoxTool.vue?vue&type=template&id=6757e87a"
import script from "./AnnotationBoxTool.vue?vue&type=script&lang=js"
export * from "./AnnotationBoxTool.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__